var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 13.3268H11.4167C12.15 13.3268 12.75 12.7268 12.75 11.9935V9.9935C12.75 9.26017 12.15 8.66017 11.4167 8.66017H10.75V7.32683C10.75 6.5935 10.15 5.9935 9.41667 5.9935H7.41667V4.66017H8.08333C8.81667 4.66017 9.41667 4.06017 9.41667 3.32683V1.32683C9.41667 0.5935 8.81667 -0.00650024 8.08333 -0.00650024H5.41667C4.68333 -0.00650024 4.08333 0.5935 4.08333 1.32683V3.32683C4.08333 4.06017 4.68333 4.66017 5.41667 4.66017H6.08333V5.9935H4.08333C3.35 5.9935 2.75 6.5935 2.75 7.32683V8.66017H2.08333C1.35 8.66017 0.75 9.26017 0.75 9.9935V11.9935C0.75 12.7268 1.35 13.3268 2.08333 13.3268H4.75C5.48333 13.3268 6.08333 12.7268 6.08333 11.9935V9.9935C6.08333 9.26017 5.48333 8.66017 4.75 8.66017H4.08333V7.32683H9.41667V8.66017H8.75C8.01667 8.66017 7.41667 9.26017 7.41667 9.9935V11.9935C7.41667 12.7268 8.01667 13.3268 8.75 13.3268Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/departmentIcon.9b36d0df5e46332525c038fd6c5c08ac.svg";
export { ForwardRef as ReactComponent };